module.exports = __webpack_public_path__ + "img/027-girl-15.0cd89295.svg";